import { Header } from "./Header";
import { Footer } from "./Footer";

export const PageShell = ({ children }) => (
  <div className="bg-[#0a0a0a] text-white min-h-screen">
    <Header />
    <main id="main-content" tabIndex={-1} className="focus:outline-none">{children}</main>
    <Footer />
  </div>
);
